var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { translateBackendErrorCode } from "@jti/fe-common";
import { getUser, isEvoError, ReferralApi } from "@jti/rest-api";
import { Button, useTranslations } from "@jti/ui";
import ReferralInput from "../../../../components/ReferralInput";
import styles from "./ReferralCode.module.scss";
export const ReferralCode = ({ isLast, currentStep, isSubmitting = false, onChangeReferralCode, onNext, }) => {
    const [refCode, setRefCode] = useState("");
    const [isReferralCodeValid, setIsReferralCodeValid] = useState(true);
    const [referralError, setReferralError] = useState("");
    const { ciam_token } = getUser();
    const { __ } = useTranslations();
    const handleRefferalCodeChange = (value) => {
        onChangeReferralCode(value);
        setRefCode(value);
        setIsReferralCodeValid(true);
    };
    const verifyRefferalCode = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const isRefferalCodeValid = yield ReferralApi.init().verifyCode(refCode, ciam_token);
            setIsReferralCodeValid(isRefferalCodeValid);
            if (isRefferalCodeValid) {
                onNext();
            }
        }
        catch (e) {
            const defaultMessage = __("auth.loyalty.errorMessage");
            if (isEvoError(e)) {
                setReferralError(translateBackendErrorCode(e.error_code, defaultMessage));
                return;
            }
            setReferralError(defaultMessage);
        }
    });
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (refCode) {
            return yield verifyRefferalCode();
        }
        onNext();
    });
    const isSubmitDisabled = () => !isReferralCodeValid;
    const submitBtnLabel = isLast
        ? __("auth.registration.referral_code.create_account")
        : __("auth.registration.referral_code.next_step");
    return (_jsxs("div", { children: [_jsx("h2", { className: styles.header, children: __("auth.registration.referral_code.screen_title", [currentStep]) }), _jsx("div", { "data-testid": "referal-block", className: styles.referralBlock, children: _jsx(ReferralInput, { errorMessage: referralError, onChange: handleRefferalCodeChange, isValidated: isReferralCodeValid }) }), _jsx(Button, { className: styles.button, onClick: handleSubmit, color: "primary", disabled: isSubmitDisabled(), isPending: isSubmitting, "data-testid": "referralCodeSubmitButton", children: submitBtnLabel })] }));
};
